import { InjectionToken } from '@angular/core'
import { DisplayAdvertisingService } from './display-advertising-service.interface'

export const DISPLAY_ADVERTISING_SERVICE = new InjectionToken<DisplayAdvertisingService>(
  'FLO.DISPLAY_ADVERTISING_SERVICE'
)
